import React from "react";
import { loadModules } from "esri-loader";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import { Link } from 'react-router-dom';

import {
    arcgisJSUrl,
    arcgisCSSUrl,
    arcgisGeocodeUrl,
    iwkPrintServiceUrl,
    restArcgis
} from "../../utilities/constants";
import manhole from "../../images/manhole.png";
import iwk from "../../images/logo.jpg";

class STPDataMap extends React.Component {
    constructor(props) {
        super(props);
        const apiUrl = arcgisJSUrl;

        this.state = {
            loading: true,
            tokenDetail: JSON.parse(localStorage.getItem("tokenDetail")),
            isChangeToken: false,
            apiUrl: apiUrl,
            apiCssUrl: apiUrl + arcgisCSSUrl,
            orderIdRandom: this.props.match.params.id,
            minScale: 7000,
            latitude: 4,
            longitude: 102,
            features: [],
            view: null,
            activeList: null
        };
    }

    async componentDidMount() {
        while (!this.state.isChangeToken) {
            try {
                await this.getToken();
                this.setState({
                    isChangeToken: true
                });
            } finally {
            }
        }
        setInterval(() => {
            this.getToken();
        }, 50000);
        await this.getMinScale();
        this.initializeMap();
    }

    getMinScale = async () => {
        fetch("api/GetData/GetConfigValues?configName=MinScale")
            .then(response => response.json())
            .then(data => {
                this.setState({ minScale: data[0].value });
            });
    };

    getGraphicAttributes = (geometry, title) => {
        var geometryData;
        var symbolData;
        var iwkAttr = this.getIWKAttributes(title);
        if (geometry.paths) {
            geometryData = {
                type: "polyline",
                paths: geometry.paths
            };
            symbolData = {
                type: "simple-line",
                color: iwkAttr.color,
                width: 4
            };
        } else if (geometry.rings) {
            geometryData = {
                type: "polygon",
                rings: geometry.rings
            };
            symbolData = {
                type: "simple-fill",
                color: [0, 0, 0, 0],
                outline: {
                    style: iwkAttr.style,
                    color: iwkAttr.color,
                    width: 2
                }
            };
        } else {
            geometry.type = "point";
            geometryData = geometry;
            symbolData = {
                type: "picture-marker",
                url: iwkAttr.url,
                color: iwkAttr.color,
                outline: {
                    color: [255, 255, 255],
                    width: 1
                }
            };
        }
        return {
            geometry: geometryData,
            symbol: symbolData
        };
    };

    getIWKAttributes(title) {
        if (title === "manholeFeatures") {
            return {
                url: manhole,
                color: [226, 119, 40]
            };
        } else if (title === "gravityMainsFeatures") {
            return {
                color: [38, 115, 0]
            };
        } else if (title === "pressurizedMainsFeatures") {
            return {
                color: [0, 115, 76]
            };
        } else if (title === "npsServiceAreaFeatures") {
            return {
                color: [115, 76, 0],
                style: "dash-dot"
            };
        } else if (title === "publicSTPFeatures") {
            return {
                color: [115, 0, 76, 255],
                style: "solid"
            };
        } else {
            return {
                color: [244, 64, 82],
                url: iwk,
                style: "solid"
            };
        }
    }

    getSimplifiedAttributes = attributes => {
        var newAttributesObj = {};
        var attributeKeys = Object.keys(attributes);
        attributeKeys.map(attr => {
            var split = attr.split(".");
            newAttributesObj[split[split.length - 1]] = attributes[attr];
        });
        return newAttributesObj;
    };

    zoomToBookmark = geometry => {
        this.state.view.goTo(geometry, {
            duration: 3500
        });
    };

    /*async checkToken() {
          var tokenDetail = localStorage.getItem("tokenDetail");
          if (tokenDetail != null) {
              tokenDetail = JSON.parse(tokenDetail);
          }
  
          if (tokenDetail == null || new Date() > new Date(tokenDetail.tokenExpired)) {
              this.state.isChangeToken = true;
  
              var myHeaders = new Headers();
              myHeaders.append('pragma', 'no-cache');
              myHeaders.append('cache-control', 'no-cache');
              myHeaders.append('Accept', 'application/json');
              myHeaders.append('Content-Type', 'application/json');
  
              var myInit = {
                  method: 'get',
                  headers: myHeaders,
              };
  
              let jj = async () => {
                  return new Promise(resolve => {
                      fetch('api/GetData/GetTokenArcgis', myInit)
                          .then(response => response.json())
                          .then(data => {
                              var dd = new Date();
                              dd.setHours(dd.getHours() + 1)
                              tokenDetail = { token: data.token, tokenExpired: dd };
                              localStorage.setItem("tokenDetail", JSON.stringify(tokenDetail));
                              resolve(1);
                          });
                  });
              };
              await jj();
              this.state.tokenDetail = JSON.parse(localStorage.getItem("tokenDetail"));
              //tokenDetail = JSON.parse(localStorage.getItem("tokenDetail"));
  
          }
          setTimeout(() => { this.checkToken() }, 30000);
      }
  
      letsWait = () => {
          console.log({ dd: this });
          return new Promise(resolve => {
              if (this.state.tokenDetail == null) {
                  console.log("token detail null");
                  setTimeout(() => { this.letsWait() }, 3000);
              }
              else {
                  resolve(1);
              }
          });
      };*/

    getToken = () => {
        return new Promise(async (resolve, reject) => {
            if (
                !this.state.tokenDetail ||
                new Date() > new Date(this.state.tokenDetail.tokenExpired)
            ) {
                try {
                    await this.fetchToken();
                } catch (err) {
                    reject(err);
                }
            }
            resolve(true);
        });
    };

    fetchToken = async () => {
        var response = await fetch("api/GetData/GetTokenArcgis");
        var data = await response.json();
        var dd = new Date();
        dd.setHours(dd.getHours() + 1);
        var tokenDetail = { token: data.token, tokenExpired: dd };
        this.setState({ tokenDetail });
        localStorage.setItem("tokenDetail", JSON.stringify(tokenDetail));
    };

    initializeMap = () => {
        loadModules(
            [
                "esri/views/MapView",
                "esri/Map",
                "esri/layers/FeatureLayer",
                "esri/widgets/Search",
                "esri/widgets/BasemapGallery",
                "esri/widgets/Expand",
                "esri/identity/IdentityManager",
                "esri/widgets/ScaleBar",
                "esri/widgets/Print",
                "esri/widgets/LayerList",
                "esri/geometry/Polygon",
                "esri/widgets/Legend",
                "esri/tasks/Locator"
            ],
            { url: this.state.apiUrl, css: this.state.apiCssUrl }
        ).then(
            async ([
                MapView,
                Map,
                FeatureLayer,
                Search,
                BasemapGallery,
                Expand,
                IdentityManager,
                ScaleBar,
                Print,
                LayerList,
                Polygon,
                Legend,
                Locator
            ]) => {
                //await this.letsWait();

                IdentityManager.registerToken({
                    server: restArcgis,
                    token: this.state.tokenDetail.token
                });

                /*this.state.isChangeToken = false;
                    let checkTokenExpired = () => {
                        if (this.state.isChangeToken) {
                            IdentityManager.registerToken({
                                server: "https://igis.iwk.com.my/geoserver/rest/services",
                                token: this.state.tokenDetail.token
                            });
                            this.state.isChangeToken = false;
                        }
                    };
        
                    setInterval(() => { checkTokenExpired() }, 5000);*/

                const map = new Map({
                    basemap: "hybrid",
                });

                const view = new MapView({
                    container: "viewDiv",
                    map: map,
                    zoom: 7,
                    center: [102, 4]
                });

                var response = await fetch(
                    "api/Order/GetPublicSTPOrder?orderIdRandom=" +
                    this.state.orderIdRandom
                );

                var data = await response.json();
                var features = await data.dataReturn;

                if (features === "UnavailableProduct") {
                    return this.props.history.push("/UnavailableProduct");
                }

                if (features === "ExpiredSubscription") {
                    return this.props.history.push("/ExpiredSubscription");
                }

                this.setState({
                    loading: false,
                    features: features[0]
                });

                var source = [];
                await features[0].map(graphic => {
                    source.push({
                        geometry: new Polygon({
                            rings: graphic.geometry.rings,
                            spatialReference: { wkid: 4326 }
                        }),
                        attributes: this.getSimplifiedAttributes(graphic.attributes)
                    });
                });
                var graphicAttr = this.getGraphicAttributes(
                    features[0][0].geometry,
                    "publicSTPFeatures"
                );
                graphicAttr.symbol.type = "simple-fill";
                var renderer = {
                    type: "simple",
                    symbol: graphicAttr.symbol
                };
                var fields = [
                    {
                        name: "OBJECTID",
                        alias: "OBJECTID",
                        type: "oid"
                    },
                    {
                        name: "ASSET_NO",
                        alias: "ASSET_NO",
                        type: "string"
                    },
                    {
                        name: "LOCATION",
                        alias: "LOCATION",
                        type: "string"
                    },
                    {
                        name: "DESIGN_PE",
                        alias: "DESIGN_PE",
                        type: "string"
                    },
                    {
                        name: "POPULATION",
                        alias: "POPULATION",
                        type: "string"
                    },
                    {
                        name: "NEWSOURCE_CODE",
                        alias: "NEWSOURCE_CODE",
                        type: "string"
                    },
                    {
                        name: "PLANT_CRITICALITY",
                        alias: "PLANT_CRITICALITY",
                        type: "string"
                    },
                    {
                        name: "PROCESS_TYPE",
                        alias: "PROCESS_TYPE",
                        type: "string"
                    },
                    {
                        name: "EFF_STD_DESIGN",
                        alias: "EFF_STD_DESIGN",
                        type: "string"
                    },
                    {
                        name: "EFF_STD_DOE",
                        alias: "EFF_STD_DOE",
                        type: "string"
                    },
                    {
                        name: "RIVER_CATCHMENT",
                        alias: "RIVER_CATCHMENT",
                        type: "string"
                    },
                    {
                        name: "RIVER_NAME",
                        alias: "RIVER_NAME",
                        type: "string"
                    },
                    {
                        name: "LAND_AREA",
                        alias: "LAND_AREA",
                        type: "string"
                    },
                    {
                        name: "LAND_STATUS",
                        alias: "LAND_STATUS",
                        type: "string"
                    },
                    {
                        name: "LAND_OWNER",
                        alias: "LAND_OWNER",
                        type: "string"
                    },
                    {
                        name: "STATE",
                        alias: "STATE",
                        type: "string"
                    },
                ];
                var layer = new FeatureLayer({
                    title: "Public STP",
                    source,
                    fields,
                    objectIdField: "ASSET_NO",
                    renderer,
                    spatialReference: {
                        wkid: 4326
                    },
                    geometryType: "polygon",
                    //minScale: this.state.minScale - 1000,
                    labelingInfo: [
                        {
                            labelExpressionInfo: { expression: "$feature.ASSET_NO" },
                            labelPlacement: "above-center",
                            //minScale: this.state.minScale - 1000,
                            symbol: {
                                type: "text",
                                font: {
                                    size: 10,
                                    family: "Arial"
                                },
                                horizontalAlignment: "left",
                                color: [115, 0, 76],
                                haloSize: 1,
                                haloColor: "white"
                            }
                        }
                    ],
                    popupTemplate: {
                        title: "{ASSET_NO}",
                        content: [
                            {
                                type: "fields",
                                fieldInfos: [
                                    {
                                        fieldName: "ASSET_NO",
                                        label: "Asset No"
                                    },
                                    {
                                        fieldName: "LOCATION",
                                        label: "Location"
                                    },
                                    {
                                        fieldName: "DESIGN_PE",
                                        label: "Design PE"
                                    },
                                    {
                                        fieldName: "POPULATION",
                                        label: "Population"
                                    },
                                    {
                                        fieldName: "NEWSOURCE_CODE",
                                        label: "Newsource Code"
                                    },
                                    {
                                        fieldName: "PLANT_CRITICALITY",
                                        label: "Plant Criticality"
                                    },
                                    {
                                        fieldName: "PROCESS_TYPE",
                                        label: "Process Type"
                                    },
                                    {
                                        fieldName: "EFF_STD_DESIGN",
                                        label: "EFF STD Design"
                                    },
                                    {
                                        fieldName: "EFF_STD_DOE",
                                        label: "EFFS TD DOE"
                                    },
                                    {
                                        fieldName: "RIVER_CATCHMENT",
                                        label: "River Catchment"
                                    },
                                    {
                                        fieldName: "RIVER_NAME",
                                        label: "River Name"
                                    },
                                    {
                                        fieldName: "LAND_AREA",
                                        label: "Land Area"
                                    },
                                    {
                                        fieldName: "LAND_STATUS",
                                        label: "Land Status"
                                    },
                                    {
                                        fieldName: "LAND_OWNER",
                                        label: "Land Owner"
                                    },
                                    {
                                        fieldName: "STATE",
                                        label: "State"
                                    },
                                ]
                            }
                        ]
                    }
                });

                await view.map.add(layer);

                view.on("pointer-move", function (evt) {
                    showCoordinates(view.toMap({ x: evt.x, y: evt.y }));
                });

                var showCoordinates = pt => {
                    this.setState({
                        latitude: pt.latitude.toFixed(3),
                        longitude: pt.longitude.toFixed(3)
                    });
                };

                view.when(() => {
                    this.setState({
                        view
                    });
                });

                document.getElementById("bookmarks").className = "d-block";/*.removeClass('d-none')*/;

                const searchWidget = new Search({
                    view: view,
                    container: "search",
                    includeDefaultSources: false,
                    sources: [
                        {
                            locator: new Locator({ url: arcgisGeocodeUrl }),
                            singleLineFieldName: "SingleLine",
                            name: "Geocoding Service",
                            placeholder: "Find Address and Place",
                            maxResults: 3,
                            maxSuggestions: 6,
                            suggestionsEnabled: true,
                            minSuggestCharacters: 0
                        }
                    ]
                });

                searchWidget.on("search-focus", () => {
                    const inputs = document.querySelectorAll(".esri-search__input");
                    for (var i = 0; i < inputs.length; i++) {
                        inputs[i].onfocusout = null;
                    }
                });

                view.ui.add(searchWidget, {
                    position: "top-left"
                });

                var basemapGallery = new BasemapGallery({
                    view: view
                });

                var scaleBar = new ScaleBar({
                    view: view,
                    unit: "dual"
                });

                var print = new Print({
                    view: view,
                    printServiceUrl: iwkPrintServiceUrl
                });

                var layerList = new LayerList({
                    view: view
                });

                var legend = new Legend({
                    view: view,
                    layerInfos: [
                        {
                            layer
                        }
                    ],
                    respectLayerVisibility: false
                });

                var bgExpand = new Expand({
                    view: view,
                    expandIconClass: "esri-icon-basemap",
                    expandTooltip: "Basemap",
                    content: basemapGallery
                });

                var printExpand = new Expand({
                    view: view,
                    expandIconClass: "esri-icon-printer",
                    expandTooltip: "Print",
                    content: print
                });

                var layerExpand = new Expand({
                    view: view,
                    expandIconClass: "esri-icon-layer-list",
                    expandTooltip: "Layer List",
                    content: layerList
                });

                var legendExpand = new Expand({
                    view,
                    expandIconClass: "esri-icon-maps",
                    expandTooltip: "Legend",
                    content: legend
                });

                var bookmarkExpand = new Expand({
                    view: view,
                    expandIconClass: "esri-icon-bookmark",
                    expandTooltip: "Bookmark",
                    content: document.getElementById("bookmarks")
                });

                view.ui.add(bookmarkExpand, "bottom-right");
                view.ui.add(bgExpand, "top-right");
                view.ui.add(scaleBar, {
                    position: "bottom-left"
                });
                view.ui.add(printExpand, {
                    position: "top-right"
                });
                view.ui.add([legendExpand, layerExpand], "top-right");
            }
        );
    };

    render() {
        return (
            <div className="border p-2" style={{ position: "relative" }}>
                <div id="viewDiv" className="mapViews"></div>
                <div id="search"></div>
                <div id="coordinates">
                    Coordinates: {this.state.latitude} , {this.state.longitude}
                </div>
                <div id="bookmarks" className="d-none">
                    <h5>
                        <span aria-hidden="true" className="esri-icon-bookmark"></span>{" "}
                        Bookmark
                    </h5>
                    {this.state.features.length > 0 && (
                        <ul className="list-group list-group-flush">
                            {this.state.features.map(feature => {
                                feature.attributes = this.getSimplifiedAttributes(
                                    feature.attributes
                                );
                                return (
                                    <li
                                        className={
                                            this.state.activeList === feature.attributes["ASSET_NO"]
                                                ? "list-group-item list-group-item-danger"
                                                : "list-group-item"
                                        }
                                        onClick={() => {
                                            this.zoomToBookmark({
                                                center: [
                                                    feature.attributes["CTX"],
                                                    feature.attributes["CTY"]
                                                ],
                                                zoom: 17
                                            });
                                            this.setState({
                                                activeList: feature.attributes["ASSET_NO"]
                                            });
                                        }}
                                        key={feature.attributes["ASSET_NO"]}
                                    >
                                        {feature.attributes["ASSET_NO"]}
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                    {this.state.features.length === 0 && !this.state.loading && (
                        <p>No data found</p>
                    )}
                    {this.state.features.length === 0 && this.state.loading && (
                        <LoadingSpinner />
                    )}
                </div>

                <div className="col-sm-12 text-center">
                    <Link className="" to="/">Go to Home </Link>
                </div> 
            </div>
        );
    }
}

export default STPDataMap;


// WEBPACK FOOTER //
// ./src/components/PurchaseProduct/STPDataMap.js